import { createAction } from 'typesafe-actions';
import * as types from './types';

export const clearAllData = createAction(types.CLEAR_ALL_DATA)();
